<template>
  <div class="mt-3">
    <h4>Scholarship info</h4>
    <b-input-group prepend="Address" class="mt-3">
      <b-form-input
        class="text-left"
        v-model="myWallet"
        placeholder="Owner wallet 0x...."
      ></b-form-input>
      <b-input-group-append>
        <b-button @click.prevent="onLoadNft" class="px-3" variant="info">
          Load NFT Scholarship
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <b-form-group
      :label="`Kuni Saru scholarship:`"
      v-slot="{ ariaDescribedby }"
      class="mt-3"
    >
      <b-form-checkbox-group
        id="checkbox-kuni-1"
        v-model="seleted"
        :options="list"
        :aria-describedby="ariaDescribedby"
        name="ck-saru-1"
      >
      </b-form-checkbox-group>
    </b-form-group>

    <b-input-group prepend="New owner" class="mt-3">
      <b-form-input
        class="text-left"
        v-model="newOwner"
        placeholder="new Owner 0x...."
      ></b-form-input>
      <b-input-group-append>
        <b-button
          @click.prevent="onCancelScholar"
          class="px-3"
          variant="warning"
          :disabled="seleted.length == 0"
        >
          Cancel
        </b-button>
        <b-button
          @click.prevent="onTransferOwner"
          class="px-3"
          variant="info"
          :disabled="seleted.length == 0"
        >
          Transfer Owner Scholarship
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import { nftScholar, transferOwnerScholar, cancelBatch } from "./nft-tool";

export default {
  name: "nft-scholar",
  props: ["mWallet"],
  data: () => ({
    myWallet: "",
    newOwner: "",
    seleted: [],
    list: [],
  }),
  created() {
    this.myWallet = this.mWallet.address;
  },
  methods: {
    async onLoadNft() {
      const ls = await nftScholar(this.myWallet || this.mWallet.address);
      this.list = ls.map((value) => ({
        text: `# ${value}`,
        value,
      }));
    },
  },
  async onTransferOwner() {
    try {
      await transferOwnerScholar(this.mWallet, this.seleted, this.newOwner);
      this.$bvToast.toast("successful!");
    } catch (err) {
      this.$bvToast.toast(
        err.reason || err.message || "KUNI: Unable to process request",
        {
          variant: "warning",
          autoHideDelay: 2000,
          title: "Warning",
        }
      );
    }
  },
  async onCancelScholar() {
    try {
      await cancelBatch(this.mWallet, this.seleted);
      this.$bvToast.toast("successful!");
    } catch (err) {
      this.$bvToast.toast(
        err.reason || err.message || "KUNI: Unable to process request",
        {
          variant: "warning",
          autoHideDelay: 2000,
          title: "Warning",
        }
      );
    }
  },
};
</script>
